<template>
  <div class="marquee-track">
    <div class="marquee-inner">
      <template v-for="_ in 3" :key="_">
        <span class="marquee-item">
          <span class="num">{{ stats?.total ?? '—' }}</span
          >&nbsp;COMPÉTITIONS LISTÉES
        </span>
        <span class="marquee-sep">◆</span>
        <span class="marquee-item">
          <span class="num">{{ stats?.onSite ?? '—' }}</span
          >&nbsp;SUR PLACE
        </span>
        <span class="marquee-sep">◆</span>
        <span class="marquee-item">
          <span class="num">{{ stats?.online ?? '—' }}</span
          >&nbsp;EN LIGNE
        </span>
        <span class="marquee-sep">◆</span>
        <span class="marquee-item">HYROX × CROSSFIT × STRONGMAN</span>
        <span class="marquee-sep">◆</span>
        <span class="marquee-item"
          >MIS À JOUR
          <ClientOnly>
            {{ lastRefreshRelative }}
            <template #fallback>—</template></ClientOnly
          ></span
        >
        <span class="marquee-sep">◆</span>
        <span class="marquee-item">FRANCE · 2026</span>
        <span class="marquee-sep">◆</span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
const { data: stats, lastRefreshRelative } = useStats();
</script>
